// action - state management
import { REGISTER, LOGIN, LOGOUT, RESET } from './actions';

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state, action) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload;
      return {
        ...state,
        user
      };
    }
    case LOGIN: {
      const { user, userData } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user,
        userData
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null,
        userData: null
      };
    }
    case RESET: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null,
        userData: null
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default auth;
